const dateFormatter = (dateobject) => {
  try {
    var datetemp = dateobject.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    return datetemp;
  } catch (_error) {
    return '-';
  }
};

const timeFormatter = (dateobject) => {
  try {
    var timetemp = dateobject.toLocaleTimeString('de-DE', {
      timeZone: 'Europe/Berlin',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
    });

    return timetemp;
  } catch (_error) {
    return '-';
  }
};

export { dateFormatter, timeFormatter };
